import { Component, OnInit, Input, SimpleChange, AfterContentChecked, ChangeDetectorRef, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';
import { QuestionControlService } from '../form/question-control.service';
import { BaseService } from '../../shared/services/base.service';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from '../../services/util.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DialogService } from '../dialog/dialog.service';
import { CompositeArrayObjectComponent } from '../composite-array/composite-array-object.component';

/**
 * This component is work with one dependent value from parent form. We can make dependent on multiple values
 */
@Component({
    selector: 'dhs-editable-table',
    templateUrl: './editable-table.component.html',
    styleUrls: ['./editable-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: EditableTableComponent,
            multi: true,
        }],
    standalone: false
})
export class EditableTableComponent implements ControlValueAccessor, AfterContentChecked, OnInit {
    @Input('value') _value: any;
    @Input() resource: string;
    @Input() datasource: any;
    @Input() fieldDataSource: any;
    @Input() parentForm: FormGroup;
    @Input() dependentField: string = "";
    editableTable: FormGroup;
    formBlocks: any = [];
    fieldGroups: any = [];
    listBlocks: any = [];
    fields: any = [];
    formArray: FormArray;
    dependentVal: string = "";
    parentFormData: any;
    selectedItems: any[] = [];
    selectedIndices: boolean[] = [];
    selectedCount = 0;
    @Input() minWidth: string;
    propagateChange = (_: any) => { };

    @Input() items: Array<any> = [];
    @Input() current_action: string = "";
    @Input() parentItem: any;
    @Output() valueAdded: EventEmitter<any> = new EventEmitter();
    constructor(private qcs: QuestionControlService,
        private baseService: BaseService,
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private cdRef: ChangeDetectorRef,
        private utilService: UtilService,
        private dialogService: DialogService,
    ) { }

    ngDoCheck() {
        if (this.dependentField != "" && this.dependentField != undefined) {
            if (this.parentForm.controls[this.dependentField]) {
                var currentDependentVal = this.parentForm.controls[this.dependentField].value;
                if (this.dependentVal != currentDependentVal) {
                    this.dependentVal = this.parentForm.controls[this.dependentField].value;
                    this.formBlocks = [];
                    this.listBlocks = [];
                    this.fields = [];
                    this.items = [];
                    this.value = [];
                    this.selectedCount = 0;
                    this.selectedItems = [];
                    this.selectedIndices = [];
                    this.formArray = this.editableTable.get('editableRows') as FormArray;
                    this.formArray.clear();
                    this.cdRef.markForCheck();
                    this.ngOnInit();
                }
            }
        }
    }
    ngOnInit() {
        if (this.parentForm) {
            this.parentFormData = this.utilService.unflatten(this.parentForm.getRawValue());
            if (this.dependentField != "" && this.dependentField != undefined) {
                if (this.parentForm.controls[this.dependentField]) {
                    this.dependentVal = this.parentForm.controls[this.dependentField].value;
                }
            }
        }
        this.baseService.getResourceDef(this.resource, (resouceDef) => {
            if (resouceDef) {
                this.formBlocks = resouceDef.form;
                if (resouceDef.form != undefined) { // This is unexptected code but use in template without this composite-object is not working
                    this.baseService.getReferredField(resouceDef.form, (response) => {
                        this.fieldGroups = response[0];
                        this.fieldGroups.fields.sort((a, b) => { return a.order - b.order });
                    });
                }
                if (resouceDef.list != null) {
                    this.listBlocks = resouceDef.list;
                    this.tablefields();
                    setTimeout(() => {
                        this.fetchData();
                    })
                    if (this.items.length > 0) { // This condition use for view
                        this.initiateForm();
                    }
                }
            }
        });
    }

    ngAfterContentChecked(): void {
        this.cdRef.detectChanges()
    }
    ngOnChanges() {
        this.cdRef.detectChanges()
    }
    ngAfterOnInit() {
        this.formArray = this.editableTable.get('editableRows') as FormArray;
    }

    tablefields() {
        this.listBlocks.fields.forEach(el => {
            if (el.component == 'hidden')
                el.hidden = true;
            else el.hidden = false;
            if (el.conditions != undefined && el.conditions.length > 0) { // This is not applicable for dynamic header
                for (let condition of el.conditions) {
                    if (eval(condition.expression)) {
                        el.hidden = false;
                    } else el.hidden = true;
                }
            }
            if (this.current_action == 'VIEW')
                el.component = 'label';

            if (el.component == 'dropdown') {
                let filter: string = "";
                if (el.datasource.filter) {
                    filter = el.datasource.filter != undefined ? this.baseService.buildDyanamicStr(el.datasource.filter, { data: this.parentFormData }) : '';
                }
                this.getDictionary(el.datasource.resource, el.datasource.query_id, el.datasource.application, el.datasource.args ? el.datasource.args : null, filter)
                    .subscribe(
                        (data) => {
                            el.options = data;
                        });
            }

            this.fields.push(el);
        });
        // dynamic field bind from datasource include here
        this.getFields();
        this.editableTable = this.fb.group({
            editableRows: this.fb.array([])
        });
    }

    getFields() {
        if (this.dependentField != "" && this.dependentField != undefined) {
            if (this.parentForm.controls[this.dependentField]) {
                this.dependentVal = this.parentForm.controls[this.dependentField].value;
            }
        }
        if (this.fieldDataSource != undefined) {
            var apiObj: any = {};
            apiObj.query_id = this.fieldDataSource.query_id;
            apiObj.resource = this.fieldDataSource.resource;
            if (this.fieldDataSource.application)
                apiObj.application = this.fieldDataSource.application;
            else
                apiObj.application = this.baseService.getAppName();
            if (this.fieldDataSource.key)
                apiObj.args = this.fieldDataSource.key + ":" + this.route.snapshot.params.id; // need to review
            else apiObj.args = "";
            if (this.fieldDataSource.filter) {
                apiObj.filter = this.fieldDataSource.filter != undefined ? this.baseService.buildDyanamicStr(this.fieldDataSource.filter, { data: this.parentFormData }) : '';
            }
            this.baseService.get(apiObj.query_id, apiObj.args, apiObj.resource, apiObj.application, apiObj.filter).subscribe(
                (data: any) => {
                    if (data.erroCode == -1) {
                        // TODO
                    } else {
                        if (data.resource != undefined && data.resource.length > 0) {
                            let dynamicfields = data.resource;
                            dynamicfields.forEach(element => {
                                let field: any = {};
                                field.name = element.name;
                                if (element.label) field.heading = element.label;
                                else if (element.heading) field.heading = element.heading;
                                if (element.component == 'textbox') {
                                    if (element.type) {
                                        if (element.type == 'number')
                                            field.component = 'numberbox'
                                        else field.component = element.component;
                                    } else
                                        field.component = element.component;
                                } else field.component = element.component;
                                this.fields.push(field);
                            });
                        }
                        this.initiateForm();
                    }

                }, error => {
                    console.log(error);
                }
            )
        }
    }

    fetchData() {
        if (this.datasource != undefined) {
            var apiObj: any = {};
            apiObj.query_id = this.datasource.query_id;
            apiObj.resource = this.datasource.resource;
            if (this.datasource.application)
                apiObj.application = this.datasource.application;
            else
                apiObj.application = this.baseService.getAppName();
            if (this.datasource.key)
                apiObj.args = this.datasource.key + ":" + this.route.snapshot.params.id; // need to review
            else apiObj.args = "";
            if (this.datasource.filter) {
                apiObj.filter = this.datasource.filter != undefined ? this.baseService.buildDyanamicStr(this.datasource.filter, { data: this.parentFormData }) : '';
            }

            this.baseService.get(apiObj.query_id, apiObj.args, apiObj.resource, apiObj.application, apiObj.filter).subscribe(
                (data: any) => {
                    if (data.erroCode == -1) {
                        // TODO
                    } else {
                        if (data.resource != undefined && data.resource.length > 0) {
                            this.items = [];
                            this.selectedIndices = [];
                            this.items = data.resource;
                            for (let i = 0; i < this.items.length; i++) {
                                if (this.items[i].sq_no == null) {
                                    this.items[i].sq_no = i;
                                }
                                if (this.items[i].selected == true) {
                                    this.selectedIndices[i] = true;
                                    const index = this.selectedItems.findIndex(item => this.isSameItem(item, this.items[i]));
                                    if (index === -1) {
                                        this.selectedCount++;
                                        this.selectedItems.push(this.items[i]);
                                    }
                                    this.value = this.selectedItems;
                                }
                            }
                        } else {
                            // TODO
                        }
                        this.initiateForm();
                    }
                }, error => {
                    console.log(error);
                }
            )
        }
    }

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = val;
        this.propagateChange(val);
    }

    writeValue(value) {
        if (value) {
            this.items = value;
            this.value = value;
            this.initiateForm();
        }
    }
    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }
    registerOnTouched(fn: any): void {

    }

    initiateForm() {
        if (this.editableTable != undefined) {
        const control = this.editableTable.get('editableRows') as FormArray;
        control.clear();
        this.items.forEach(element => {
            let group: any = {};
            this.fields.forEach(field => {
                let val = element[field.name];
                if (field.component == 'dropdown') {
                    if (val == undefined)
                        val = "";
                }
                group[field.name] = field.required ? new FormControl(val, Validators.required)
                    : new FormControl(val);
            });
            control.push(new FormGroup(group))
        });
        }
    }

    get getFormControls() {
        const control = this.editableTable.get('editableRows') as FormArray;
        if (control != null) {
            this.items = control.value; // need to check again;
            if (this.listBlocks.selectAll) {
                if (this.selectedIndices != null) {
                    this.selectedCount = 0;
                    for (let i = 0; i < this.items.length; i++) {
                        const index = this.selectedItems.findIndex(item => this.isSameItem(item, this.items[i]));
                        if (index > -1) {
                            this.selectedCount++;
                            this.selectedItems[index] = this.items[i];
                        }
                    }
                }
            } else {
                this.value = this.items;
            }
        }
        this.setTableWidth();
        return control;
    }

    onAllChecked(checked: boolean) {
        this.items.forEach((item, index) => {
            this.checkItem(checked, index);
        });
    }

    onItemChecked(checked: boolean, index: number) {
        this.checkItem(checked, index);

    }

    private checkItem(checked: boolean, index: number) {
        this.selectedIndices[index] = checked;
        const pos = this.selectedItems.findIndex(i => this.isSameItem(i, this.items[index]));

        if (checked) {
            if (pos === -1) {
                this.selectedCount++;
                this.selectedItems.push(this.items[index]);
            }
        } else {
            if (pos > -1) {
                this.selectedCount--;
                this.selectedItems.splice(pos, 1);
            }
        }
        this.value = this.selectedItems;
    }

    private isSameItem(i1: any, i2: any): boolean {
        const key = this.listBlocks.selectAll.key;
        return this.getNestedValue(i1, key) === this.getNestedValue(i2, key);
    }

    private getNestedValue(obj: any, key: string): any {
        const keys = key.split('.');
        for (const k of keys) {
            obj = obj[k];
        }
        return obj;
    }

    getIdKey(option, key) {
        if (option.hasOwnProperty(key.getterKey)) {
            return option[key.getterKey];
        }
    }

    getValue(option, field) {
        if (field.format != undefined) {
            if (field.format != undefined && option != undefined && eval(field.format)(option) != undefined) {
                return eval(field.format)(option);
            }
        } else if (option.hasOwnProperty(field.getterValue)) {
            return option[field.getterValue];
        }
    }

    getDictionary(url: string, queryId: any = false, application?: any, args?: any, filter?: any): Observable<any> {
        // var queryId = (queryId) ? queryId : 'GET_ALL';
        var application = (application) ? application : '';
        if (args == null)
            args = '';
        return this.baseService.getDataAsPerResource(queryId, args, url, application, filter)
            .pipe(map(res => this.extractData(res.resource)));

    }

    private extractData(res) {
        let data = (res != undefined) ? res.data || res : [];
        return data;
    }

    addRow(index: number) {
        let item = this.items[index];
        if (item != undefined) {
            var itemObj: any = {};
            itemObj = Object.assign({}, item);
            if (itemObj.id) itemObj.id = null;
            this.items.splice(index + 1, 0, itemObj);
            this.value = this.items;
            this.initiateForm();
        }
    }

    editRow(index: number) {
        let activatedResource = this.route.snapshot.data.decorator;
        let action = 'MODIFY';
        let dataVal = this.items[index];

        let newobj = { data: { formblocks: this.formBlocks, data: dataVal, activatedResource: activatedResource, action: action } };

        this.dialogService.open(CompositeArrayObjectComponent, newobj).afterClosed.subscribe(
            response => {
                if (response != null) {
                    debugger;
                    this.items.splice(index, 1);
                    this.items.push(response.result);
                    this.value = this.items;
                    this.initiateForm();
                }
            });
    }

    removeRow(index: number) {
        if (this.items.length > 1) {
            this.items.splice(index, 1);
            this.value = this.items;
            this.initiateForm();

            this.valueAdded.emit({ type: true, items: this.items });
        }
        return false;
    }

    onDropDownChange(action: any, field: any, index: any) {
        let fieldOption = field.options.find(x => x[field.getterKey] == action.target.value);

        if (fieldOption != null) {
            if (field.dependents) {
                for (let i = 0; i < field.dependents.length; i++) {
                    var dependent = field.dependents[i];
                    if (dependent.action == 'populate_field') {
                        const myForm = (this.editableTable.get('editableRows') as FormArray).at(index);
                        myForm.get(dependent.dependent_field).setValue(fieldOption[dependent.value]);
                        let item = this.items[index];
                        item[dependent.dependent_field] = fieldOption[dependent.value];
                        this.value = this.items;
                    }
                }
            }
        }
        else {
            if (fieldOption == undefined) {
                if (field.dependents) {
                    for (let i = 0; i < field.dependents.length; i++) {
                        var dependent = field.dependents[i];
                        if (dependent.action == 'populate_field') {
                            const myForm = (this.editableTable.get('editableRows') as FormArray).at(index);
                            myForm.get(dependent.dependent_field).setValue('');
                            let item = this.items[index];
                            item[dependent.dependent_field] = '';
                            this.value = this.items;
                        }
                    }
                }
            }
        }
    }

    setTableWidth() { // This a special case for plan_diet case
        if (this.parentForm != null && this.parentForm.controls != null && this.parentForm.controls["minWidth"] != null) {
            let minWidth = this.parentForm.controls["minWidth"].value;
            if (minWidth != "") {
                this.minWidth = minWidth;
            }
        }
    }

    getFormattedValue(index: any, field: any) {
        const myForm = (this.editableTable.get('editableRows') as FormArray).at(index);
        return myForm.get(field.name).value;
    }
}